import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Navbar from 'react-bootstrap/lib/Navbar';
import { FormattedMessage } from 'react-intl';
import { get, last } from 'lodash';
import { getLocale } from '../selectors';
import { DEFAULT_LOCALE } from '../utils/constants';

const PORTAL_MENU = [
  { path: 'about-portal', intlKey: 'about.portal' },
  { path: 'benefits', intlKey: 'benefits' },
  { path: 'project-partners', intlKey: 'project.partners' },
  { path: 'endorsements', intlKey: 'endorsements' },
  { path: 'about-us', intlKey: 'about.us' },
  { path: 'links', intlKey: 'jurisdictions.websites' },
  { path: 'jurisdictions-disclaimers', intlKey: 'jurisdictions.disclaimers' },
  { path: 'rss-feed', intlKey: 'rss.feed' },
];

class NavbarTop extends Component {
  render() {
    const isActive = (routeKey) => {
      const lastRoute = last(this.context.router.routes);
      const currentRouteKey = get(lastRoute, 'routeKey');
      if(currentRouteKey)
        return currentRouteKey === routeKey;
      return this.context.router.isActive(routeKey);
    };

    const currentLocale = getLocale();
    const langParam = currentLocale === DEFAULT_LOCALE ? '' : `?lang=${currentLocale}`;

     return (
      <Navbar className="notranslate">
        <Navbar.Header>
          <Navbar.Brand>
            <a>
              <FormattedMessage id="navbar.brand"/>
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <ul className="nav navbar-nav navbar-left hidden-xs">
            <MenuItem href={`#/${langParam}`} active={isActive('recalls-list')}>
              <FormattedMessage id="navbar.home"/>
            </MenuItem>
            <Dropdown componentClass="li" id="portal-menu">
              <Dropdown.Toggle useAnchor>
                <FormattedMessage id="navbar.thePortal"/>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {PORTAL_MENU.map(({ path, intlKey }) => (
                  <MenuItem href={`#/${path}${langParam}`} active={isActive(path)} key={`menu_${path}`}
                            onClick={e => document.activeElement.blur()}>
                    <FormattedMessage id={intlKey}/>
                  </MenuItem>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <MenuItem href={`#/dashboard${langParam}`} active={isActive('dashboard')}>
              <FormattedMessage id="navbar.dashboard"/>
            </MenuItem>
          </ul>
          </Navbar.Collapse>


          <Navbar.Collapse>
          <ul className="nav navbar-nav hidden-sm hidden-md hidden-lg hidden-xl">
            <MenuItem href={`#/${langParam}`} active={isActive('recalls-list')}>
              <FormattedMessage id="navbar.home"/>
            </MenuItem>
            {PORTAL_MENU.map(({ path, intlKey }) => (
              <MenuItem href={`#/${path}${langParam}`} active={isActive(path)} key={`menu_${path}`}
                        onClick={e => document.activeElement.blur()}>
                <FormattedMessage id={intlKey}/>
              </MenuItem>
            ))}
          </ul>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

NavbarTop.contextTypes = {
  router: React.PropTypes.object
};

export default NavbarTop;



// WEBPACK FOOTER //
// ./src/views/navbar-top.js